<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			id="peopleTable"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			height="340px"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			:span-method="objectSpanMethod"
		>
			<el-table-column prop="admin_id" label="id" width="80px">
			</el-table-column>
			<el-table-column prop="user_name" label="人员名称" show-overflow-tooltip>
			</el-table-column>

			<el-table-column prop="edit_type" label="操作类型">
				<template slot-scope="scope">
					<span v-if="scope.row.edit_type == 1">PR</span>
					<span v-if="scope.row.edit_type == 2">人工原创</span>
					<span v-if="scope.row.edit_type == 6">AI原创</span>
					<span v-if="scope.row.edit_type == 3">翻译</span>
					<span v-if="scope.row.edit_type == 4">转载</span>
					<span v-if="scope.row.edit_type == 5">审核</span>
					<span v-if="scope.row.edit_type == 7">AI转载</span>
				</template>
			</el-table-column>
			<el-table-column prop="count" label="数量"> </el-table-column>
		</el-table>
	</div>
</template>

<script>
export default {
	props: ["tableData"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0 || columnIndex === 1) {
				if (rowIndex % 5 === 0) {
					return {
						rowspan: 5,
						colspan: 1,
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0,
					};
				}
			}
		},
	},
};
</script>

<style scoped></style>
